import {Breadcrumbs, ErrorPopup, Notice, Title} from '@management-ui/core';
import {Box} from '@mui/material';
import {reverse} from 'named-urls';
import React from 'react';
import OrderStatus from '../../../../components/OrderStatus';
import routes from '../../../../routes';

const Wrapper = ({title, list, loading, crumbs, errors, children}) => {
  return (
    <>
      <Breadcrumbs crumbs={crumbs}/>
      <Title title={title} loading={loading}>
        {list ? (
          <Box display="flex" flex={1} justifyContent="flex-end"><OrderStatus order={list}/></Box>
        ) : null}
      </Title>
      <Notice
        display={list && (list.archived || list.order.archived)}
        message={[
          'This packing list has been archived and is therefore no longer available.',
          list?.deleted_at ? 'You won\'t be able to modify it unless it is restored.' : 'A relation was archived therefore you can not restore it directly'
        ].join(' ')}
      />
      {children}
      <ErrorPopup errors={['packingList']} messages={errors}/>
    </>
  );
}

Wrapper.standardCrumbs = [
  {title: 'Sales Orders', link: routes.salesOrders.index}
];
Wrapper.archiveCrumbs = [
  {title: 'Archive', link: routes.archive.index},
  {title: 'Sales Orders', link: reverse(routes.archive.index, {tab: 'sales-orders'})}
];

export default Wrapper;
